import {twx} from '../../utils/tailwindUtils';
import {UnstyledButton} from '../Inputs/Button';

const NavigationBarTab = ({icon, label, isActive, className, ...restProps}) => {
    return (
        <UnstyledButton
            className={twx('flex flex-1 cursor-pointer flex-col items-center py-4', className)}
            {...restProps}
        >
            <span
                className={twx(
                    'flex h-8 w-full max-w-16 items-center justify-center rounded-full',
                    isActive && 'bg-[#B2F1F1]'
                )}
            >
                {icon}
            </span>

            <span
                className={twx(
                    'w-full overflow-hidden text-center text-[12px] leading-5 tracking-normal text-[#1D1B20] dark:text-color-secondary',
                    isActive && 'font-bold'
                )}
            >
                {label}
            </span>
        </UnstyledButton>
    );
};

export default NavigationBarTab;
